import script from "./QuizzQcmQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzQcmQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzQcmQuestion.vue?vue&type=style&index=0&id=0acf081f&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acf081f"]])

export default __exports__